import { formatTimezoneOffset } from '@common/utils/dateHelper';
import api from './baseApi';

export const fabAccessLogApi = {
  getMonthTree() {
    return api.get('/v1/manage-admin/analytic/month_tree');
  },
  getFilterOptions() {
    return api.get('/v1/manage-admin/analytic/filter_options');
  },
  getListAccessLogs(params) {
    return api.get('/v1/manage-admin/analytic/list', { params });
  },
  exportListAccessLogs(params) {
    const now = new Date();
    const offsetMinutes = -now.getTimezoneOffset();
    return api.get('/v1/manage-admin/analytic/list_export', {
      params: {
        ...params,
        timezone: formatTimezoneOffset(offsetMinutes),
      },
      responseType: 'blob',
    });
  },
  getSummaryAccessLogs(params) {
    return api.get('/v1/manage-admin/analytic/summary', { params });
  },
  exportSummaryAccessLogs(params) {
    const now = new Date();
    const offsetMinutes = -now.getTimezoneOffset();
    return api.get('/v1/manage-admin/analytic/summary_export', {
      params: {
        ...params,
        timezone: formatTimezoneOffset(offsetMinutes),
      },
      responseType: 'blob',
    });
  },
  /**
   * Top 10 layout
   */
  getTopLayoutByTotalVisits(params) {
    return api.get('/v1/manage-admin/analytic/layout/top_visits', { params });
  },
  getTopLayoutByTotalPlayTimes(params) {
    return api.get('/v1/manage-admin/analytic/layout/top_playtimes', {
      params,
    });
  },
  /**
   * Top 10 user
   */
  getTopUserByTotalVisits(params) {
    return api.get('/v1/manage-admin/analytic/user/top_visits', { params });
  },
  getTopUserByTotalPlayTimes(params) {
    return api.get('/v1/manage-admin/analytic/user/top_playtimes', {
      params,
    });
  },
};

export const a = () => null;
